import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/layout/Navbar/Navbar";
import Footer from "./components/layout/Footer/Footer";
import ScrollToTop from "./components/ui/ScrollToTop/ScrollToTop";
import ScrollToTopOnNavigate from "./components/ui/ScrollToTopOnNavigate/ScrollToTopOnNavigate";
import Loader from "./components/ui/Loader/Loader";
import Home from "./pages/Home/Home";
import Services from "./pages/Services/Services";
import HowItWorks from "./pages/HowItWorks/HowItWorks";
import Contact from "./pages/Contact/Contact";
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import TermsOfService from "./pages/Legal/TermsOfService";
import "./App.css";

function App() {
  const [loading, setLoading] = useState(true);
  const [ready, setReady] = useState(false);

  const handleLoaderComplete = () => {
    setLoading(false);
    setTimeout(() => setReady(true), 100);
  };

  return (
    <>
      {loading && <Loader onComplete={handleLoaderComplete} />}

      <div
        id="page-transition-overlay"
        style={{ display: "none" }}
        className="page-transition-overlay"
      >
        <span className="page-transition-overlay__logo">ASCENCIO</span>
      </div>

      <Router>
        <ScrollToTopOnNavigate />
        <div
          className="App"
          style={{ visibility: loading ? "hidden" : "visible" }}
        >
          <Navbar />
          <Routes>
            <Route path="/" element={<Home ready={ready} />} />
            <Route path="/services" element={<Services />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
          <Footer />
          <ScrollToTop />
        </div>
      </Router>
    </>
  );
}

export default App;
